import { useMutation, useQuery } from '@tanstack/react-query';
import {
  App,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Flex,
  Form,
  Input,
  Row,
  Select,
  Table,
} from 'antd';
import React, { useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { getGeneraledgerReport } from '../../network/generaledgerReport';
import DashboardCards from '../Dashboard/DashboardCards';
import {
  getZatcaDetailsReport,
  getZatcaSummaryReport,
} from '../../network/ZatcaReport';
import ReactApexChart from 'react-apexcharts';
const { RangePicker } = DatePicker;
const ZatcaSummaryReport = ({ t }) => {
  const { currentLang, companyName } = useSelector((state) => state.user);
  const [form] = Form.useForm();
  const [sourceData, setSourceData] = useState({
    from_date_filter: dayjs().startOf('month').format('YYYY-MM-DD'),
    to_date_filter: dayjs().endOf('month').format('YYYY-MM-DD'),
    integration_status_filter: 'All',
  });

  const { data: stockBalanceDetails, isLoading } = useQuery({
    queryKey: [
      queryKeys.getZatcaSummaryReport,
      currentLang,
      companyName,
      sourceData.from_date_filter,
      sourceData.to_date_filter,
    ],
    queryFn: () =>
      getZatcaSummaryReport({
        currentLang,
        companyName,
        from_date_filter: sourceData.from_date_filter,
        to_date_filter: sourceData.to_date_filter,
      }),
  });
  const columns = stockBalanceDetails?.message?.columns?.map((col) => ({
    title: col?.label,
    dataIndex: col?.fieldname,
    key: col?.fieldname,
    // width: col.width,
  }));

  const dataSource = stockBalanceDetails?.message?.result?.map(
    (item, index) => ({
      key: index,
      ...item,
      date: dayjs(item.date).format('YYYY-MM-DD'),
      posting_time: dayjs(item.posting_time).format('HH:mm'),
    })
  );

  const chart = stockBalanceDetails?.message?.chart;

  const seriesChart = chart?.data?.datasets?.[0]?.values || [];
  const convertColor = (color) => {
    const colorMap = {
      green: '#228B22',
      red: '#A52A2A',
      blue: '#1951A3',
      orange: '#FF4500',
      yellow: '#FFD700',
      gray: '#808080',
      black: '#000000',
    };
    return colorMap[color.toLowerCase()] || color;
  };

  const chartColors = chart?.colors?.map((c) => convertColor(c)) || ['#0b9640'];

  const optionsChart = {
    chart: {
      type: chart?.type || 'pie',
    },
    labels: chart?.data?.labels || [],
    // colors: chart?.colors || ['#0b9640'],
    colors: chartColors,

    legend: {
      position: 'bottom',
    },
    stroke: {
      show: true,
    },
    title: {
      text: chart?.title || '',
      align: 'center',
      style: {
        fontSize: '16px',
        fontWeight: 'bold',
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  return (
    <div className="stock-balance-report">
      <DashboardCards t={t} />
      {isLoading ? (
        <Card className="mt-5" loading></Card>
      ) : (
        <Card className="mt-5">
          <div id="chart" className="p-[20px]">
            <ReactApexChart
              options={optionsChart}
              series={seriesChart}
              type={chart?.type || 'pie'}
              height={chart?.height || 310}
            />
          </div>
        </Card>
      )}

      <Card className="mt-5">
        <Row gutter={[16, 0]}>
          <Col xs={24} md={12} xl={8} xxl={6}>
            <RangePicker
              format="YYYY-MM-DD"
              style={{ width: '100%' }}
              value={[
                dayjs(sourceData.from_date_filter),
                dayjs(sourceData.to_date_filter),
              ]}
              placeholder={['From Date', 'To Date']}
              defaultValue={[dayjs().startOf('month'), dayjs().endOf('month')]}
              // defaultValue={[dayjs(), dayjs().add(1, 'month')]}
              onChange={(dates, dateStrings) => {
                setSourceData({
                  from_date_filter: dateStrings[0],
                  to_date_filter: dateStrings[1],
                });
              }}
            />
          </Col>
        </Row>
        <Table
          className="table_custom"
          columns={columns}
          dataSource={dataSource}
          loading={isLoading}
          //   pagination={{ hideOnSinglePage: true }}
          pagination={false}
          rowKey="key"
          scroll={{ x: 'max-content' }}
          // summary={() => (
          //   <Table.Summary.Row>
          //     {totalRow?.map((value, index) => (
          //       <Table.Summary.Cell key={index}>{value}</Table.Summary.Cell>
          //     ))}
          //   </Table.Summary.Row>
          // )}
        />
      </Card>
    </div>
  );
};

export default ZatcaSummaryReport;
